import Pusher from 'pusher-js'
import store from '../../store'
import {controlReceived} from '../../actions/control'
import {pusherPollReceived} from '../../actions/polls'
import {onboardingStatusUpdateRecieved} from '../../actions/meta'
import {sectionControlReceived} from '../../actions/sectionControl'
import {fetchSearchKey} from '../../actions/searchKey'
import {repoAddedPusherReceived,repoRemovedPusherReceived} from '../../actions/repos'
import {permissionUpdatedPusherReceived} from '../../actions/permissions'



export function appPusherSetup(userId,onSetupComplete) {
	//Pusher.logToConsole = true 
	var pusher = new Pusher(process.env.REACT_APP_PLICKERS_PUSHER_TOKEN, {
		encrypted: true
	})

	var channel = pusher.subscribe(userId)
	
	channel.bind('control-update', handleControlUpdatePusherReceived)
	channel.bind('response-update', handleResponseUpdatePusherReceived)
	channel.bind('onboarding-status-update', handleOnboardingStatusUpdatePusherReceived)
	channel.bind('section-control', handleSectionControlUpdatePusherReceived)
	channel.bind('repo added', handleRepoAddedPusherReceived)
	channel.bind('repo removed', handleRepoRemovedPusherReceived)
	channel.bind('permission updated', handlePermissionUpdatedPusherReceived)
	
	onSetupComplete()
}


function handleControlUpdatePusherReceived(data){
	store.dispatch(controlReceived(data.message))
}

function handleResponseUpdatePusherReceived(data){
	store.dispatch(pusherPollReceived(data))
}


function handleOnboardingStatusUpdatePusherReceived(data){
	store.dispatch(onboardingStatusUpdateRecieved(data.status))
}


function handleSectionControlUpdatePusherReceived(data){
	store.dispatch(sectionControlReceived(data))
}

function handleRepoAddedPusherReceived(data){
	store.dispatch(fetchSearchKey())
	store.dispatch(repoAddedPusherReceived(data.repo))
}


function handlePermissionUpdatedPusherReceived(data){
	store.dispatch(fetchSearchKey())
	store.dispatch(permissionUpdatedPusherReceived(data.permission))
}


function handleRepoRemovedPusherReceived(data){
	store.dispatch(fetchSearchKey())
	store.dispatch(repoRemovedPusherReceived(data.repoId))
}




// WEBPACK FOOTER //
// ./src/utils/pusher/appPusherSetup.js